/**
 * A gateway's letter in its colour (A blue, B purple, C pink…), exactly as
 * the Gateways list paints it, so a drop row and its picker name the same
 * gateway the same way (user, 19/10/2026: "I want colours for each icon").
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { gwColor, gwLetter } from '../../../../gateways/cards/strategy-copy';

export const GatewayLetter: FC<{ index: number; className?: string }> = ({ index, className = 'h-4 w-4 text-[10px]' }) => (
  <span
    className={`flex shrink-0 items-center justify-center rounded font-mono font-bold text-white ${className}`}
    style={{ backgroundColor: gwColor(index) }}
    aria-hidden
  >
    {gwLetter(index)}
  </span>
);
